var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"u-typography-helvetica u-text u-text--s text-align-center q-mb16"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_c('u-textarea',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }